import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormField from '../../../components/FormField'
import Select from './Select'
import OrgRow from './OrgRow'
import Organization from './Organization'
import RemoveOrgModal from './RemoveOrgModal'
import { newOrganization, hideDeleteModal } from '../actions'

class OrganizationContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addNew: false,
      newOrg: {
        orgName: '',
        contact: this.props.myeducatorUsers[0].id,
        providerId: '',
        baseUrl: '',
        oauthToken: '',
      },
    }
  }

  handleOrgChange = event => {
    let {
      target: { name, value },
    } = event
    this.setState({
      newOrg: {
        ...this.state.newOrg,
        [name]: value,
      },
    })
  }

  handleSelect = event => {
    this.setState({
      newOrg: {
        ...this.state.newOrg,
        contact: event.target.value,
      },
    })
  }

  toggleNew = () => {
    this.setState(prevState => ({
      addNew: !prevState.addNew,
    }))
  }

  saveNewOrg = () => {
    this.props.createOrganization(this.state.newOrg)
    this.toggleNew()
    this.setState({
      newOrg: {
        ...this.state.newOrg,
        orgName: '',
        providerId: '',
        baseUrl: '',
        oauthToken: '',
      },
    })
  }

  render() {
    let orgsMap = this.props.organizations.reduce((map, org) => {
      map[org.id] = { ...org }
      return map
    }, {})

    if (this.props.selectedOrgId) {
      return (
        <Organization
          orgId={this.props.selectedOrgId}
          orgName={orgsMap[this.props.selectedOrgId].name}
          contact={orgsMap[this.props.selectedOrgId].mainContact}
          providerId={orgsMap[this.props.selectedOrgId].providerId}
          baseUrl={orgsMap[this.props.selectedOrgId].baseUrl}
          sfUserId={orgsMap[this.props.selectedOrgId].sfUserId}
          clientId={orgsMap[this.props.selectedOrgId].clientId}
          clientSecret={orgsMap[this.props.selectedOrgId].clientSecret}
          oauthToken={orgsMap[this.props.selectedOrgId].oauthToken}
          ocnUpdated={orgsMap[this.props.selectedOrgId].ocnUpdated}
          hasBadData={orgsMap[this.props.selectedOrgId].hasBadData}
        />
      )
    }

    let orgs = this.props.organizations.map(org => {
      return (
        <OrgRow
          key={org.id}
          orgId={org.id}
          orgName={org.name}
          contact={org.mainContact}
          providerId={org.providerId}
          oauthToken={org.oauthToken}
          sfUserId={org.sfUserId}
          clientId={org.clientId}
          clientSecret={org.clientSecret}
          baseUrl={org.baseUrl}
        />
      )
    })

    let newRow = this.state.addNew ? (
      <tr>
        <td>
          <FormField
            name="orgName"
            label={null}
            value={this.state.newOrg.orgName}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <Select
            user={this.state.newOrg.contact}
            users={this.props.myeducatorUsers}
            handler={this.handleSelect}
          />
        </td>
        <td>
          <FormField
            name="providerId"
            label={null}
            value={this.state.newOrg.providerId}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="baseUrl"
            label={null}
            value={this.state.newOrg.baseUrl}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="sfUserId"
            label={null}
            value={this.state.newOrg.sfUserId}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="clientId"
            label={null}
            value={this.state.newOrg.oauthToken}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="clientSecret"
            label={null}
            value={this.state.newOrg.oauthToken}
            handler={this.handleOrgChange}
            type="text"
          />
        </td>
        <td>
          <button onClick={this.saveNewOrg} className="btn btn-myed btn-primary btn-primary-myed">
            Save
          </button>
        </td>
      </tr>
    ) : null

    let toggleButton = this.state.addNew ? (
      <button onClick={this.toggleNew} className="btn btn-danger">
        <i className="fa fa-plus" /> Cancel
      </button>
    ) : (
      <button onClick={this.toggleNew} className="btn btn-myed btn-primary btn-primary-myed">
        <i className="fa fa-plus" /> Add New
      </button>
    )

    return (
      <div className="p-3">
        <div>{toggleButton}</div>
        <table className="table striped">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Contact at MyEducator</th>
              <th>Provider ID</th>
              <th>Base API URL</th>
              <th>SF User ID</th>
              <th>Client ID</th>
              <th>Client Secret</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {newRow}
            {orgs}
          </tbody>
        </table>
        <RemoveOrgModal
          show={this.props.showRemoveModal}
          close={this.props.hideDeleteModal}
        />
      </div>
    )
  }
}

OrganizationContainer.propTypes = {
  organizations: PropTypes.array,
  myeducatorUsers: PropTypes.array,
  selectedOrgId: PropTypes.string,
  showRemoveModal: PropTypes.bool,
  createOrganization: PropTypes.func,
  hideDeleteModal: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    organizations: state.organizations,
    myeducatorUsers: state.myeducatorUsers,
    selectedOrgId: state.selectedOrgId,
    showRemoveModal: state.showRemoveModal,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    createOrganization: orgData => {
      dispatch(newOrganization(orgData))
    },
    hideDeleteModal: () => {
      dispatch(hideDeleteModal())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationContainer)
